import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { TextField } from '../../../../components/fields';
import { required, minLength8, password } from '../../../../utilities/validation';
import messages from '../../../../text/messages';
import { FormattedMessage } from 'react-intl';

class ResetPassword extends React.Component {
    render() {
        const { handleSubmit, submitting } = this.props;

        return (
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <Field name="code" validate={[required]} component={TextField} placeholder={messages.verificationCode} />
                </div>
                <div className="form-group ignored-password">
                    <Field
                        name="newPassword"
                        component={TextField}
                        validate={[required, minLength8, ...password]}
                        type="text"
                        placeholder={messages.newPassword}
                    />
                </div>

                <div className="form-group">
                    <button type="submit" className="btn btn-success btn-block" disabled={submitting}>
                        <FormattedMessage {...messages.submit} />
                    </button>
                </div>
            </form>
        );
    }
}

ResetPassword.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

ResetPassword.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

export default reduxForm({ form: 'ResetPassword', destroyOnUnmount: true })(ResetPassword);



// WEBPACK FOOTER //
// ./src/pages/account/forms/reset/index.jsx